import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { FormControl, TextField } from "@mui/material";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
// import Paper from '@mui/material/Paper';
// import { styled } from '@mui/material/styles';
import { getRequestGlobal } from "../../../API/global";
import InputLabel from "@mui/material/InputLabel";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { Typography } from "@mui/material";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const DetailsOfWebSeries = ({
  formData,
  setFormData,
  errors,
  setWebSeriesErrors,
}) => {
  const [language, setLanguage] = useState({});
  const [genre, setGenre] = useState({});
  const [subtitlelanguage, setSubtitleLanguage] = useState({});
  const [openMultiProduction, setOpenMultiProduction] = React.useState(false);

  useEffect(() => {
    getRequestGlobal("language_list", {})
      .then((data) => {
        // console.log(data, "data details")
        setLanguage(data.data);
      })
      .catch((error) => {});
    getRequestGlobal("genre", {})
      .then((data) => {
        // console.log(data, "data information")
        setGenre(data.data);
      })
      .catch((error) => {});
    getRequestGlobal("language_list", {})
      .then((data) => {
        // console.log({ data })
        // console.log(data, "subtitle language")
        setSubtitleLanguage(data.data);
      })
      .catch((error) => {});
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    // console.log("")
    setFormData({
      ...formData,
      [name]: value,
    });
    errors[name] = "";
    setWebSeriesErrors(errors);
  };

  const handleChangeGenre = (e) => {
    const { name, value } = e.target;
    // console.log("")
    setFormData({
      ...formData,
      [name]: value,
    });
    errors[name] = "";
    errors["other_genre"] = "";
    setWebSeriesErrors(errors);
  };

  const handleChangeOtherLanguage = (e) => {
    const { name, value } = e.target;
    // console.log("")
    setFormData({
      ...formData,
      [name]: value,
    });
    errors[name] = "";
    errors["other_language"] = "";
    setWebSeriesErrors(errors);
  };

  const handleChangeSubtitleLanguage = (e) => {
    const { name, value } = e.target;
    // console.log("")
    setFormData({
      ...formData,
      [name]: value,
    });
    errors[name] = "";
    errors["other_subtitle_language"] = "";
    setWebSeriesErrors(errors);
  };

  const handleCloseEnglishSubtitle = () => {
    setOpenMultiProduction(false);
  };

  const handleMultiProductionChange = (e) => {
    const { name, value } = e.target;

    if (value === 0 || value === "0") {
      setOpenMultiProduction(true);
      setFormData({
        ...formData,
        [name]: null,
      });
    } else {
      setFormData({
        ...formData,
        [name]: parseInt(value),
      });
      errors[name] = "";
      setWebSeriesErrors(errors);
    }
  };
  return (
    <>
      <h5>
        1. Details of Web Series<span className="text-danger">*</span>
      </h5>
      <form>
        <Grid container spacing={2} className="mt-2">
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Box>
              <TextField
                variant="outlined"
                label={
                  <span>
                    (a) Title of Web Series (in the original language of
                    release)
                    <span style={{ color: "red" }}>*</span>
                  </span>
                }
                type="text"
                fullWidth
                name="title"
                value={formData.title}
                onChange={handleChange}
              />
            </Box>
            {errors.title && <p className="text-danger">{errors.title}</p>}
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Box>
              <TextField
                label={
                  <span>
                    (b) English translation of the title
                    <span style={{ color: "red" }}>*</span>
                  </span>
                }
                type="text"
                fullWidth
                name="title_in_english"
                value={formData.title_in_english}
                onChange={handleChange}
              />
            </Box>
            {errors.title_in_english && (
              <p className="text-danger">{errors.title_in_english}</p>
            )}
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={6}>
            <div>
              <FormControl
                sx={{
                  width: "100%",
                  borderRadius: "5px",
                }}
                fullWidth
              >
                <InputLabel id="demo-simple-select-label">
                  (c) Genre <span style={{ color: "red" }}>*</span>
                </InputLabel>
                <Select
                  name="genre_id"
                  value={formData.genre_id || ""}
                  onChange={handleChange}
                  inputProps={{ "aria-label": "Genre id" }}
                  label={
                    <span>
                      Genre<span style={{ color: "red" }}>*</span>
                    </span>
                  }
                >
                  <MenuItem disabled>Genre</MenuItem>
                  {Object.entries(genre).map(([key, value]) => (
                    <MenuItem key={key} value={key}>
                      {value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {errors.genre_id && (
                <p className="text-danger">{errors.genre_id}</p>
              )}
            </div>
          </Grid>

          {formData.genre_id == 25 ? (
            <>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  id="other_genre"
                  label={
                    <span>
                      (c.i) Other Genre<span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  multiline
                  fullWidth
                  // maxRows={4}
                  name="other_genre"
                  value={formData.other_genre || ""}
                  // onChange={handleChange}
                  onChange={handleChangeGenre}
                />
                {errors.other_genre && (
                  <p className="text-danger">{errors.other_genre}</p>
                )}
              </Grid>
            </>
          ) : (
            <>
              <Grid item xs={12} sm={12} md={6} lg={6}></Grid>
            </>
          )}

          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Box>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  (d) Language in which the Web Series was originally released{" "}
                  <span style={{ color: "red" }}>*</span>
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  onChange={handleChange}
                  name="language_id"
                  label={
                    <span>
                      Language in which the Web Series was originally released
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  value={formData.language_id || ""}
                  inputProps={{
                    "aria-label":
                      "Language in which the Web Series was originally released",
                  }}
                >
                  <MenuItem disabled>
                    Language in which the Web Series was originally released
                  </MenuItem>

                  {Object.entries(language).map(([key, value]) => (
                    <MenuItem key={key} value={key}>
                      {value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {errors.language_id && (
                <p className="text-danger">{errors.language_id}</p>
              )}
            </Box>
          </Grid>

          {formData.language_id == 20 ? (
            <>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  id="other_language"
                  label={
                    <span>
                      (d.i) Other Language
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  multiline
                  fullWidth
                  // maxRows={4}
                  name="other_language"
                  value={formData.other_language || ""}
                  // onChange={handleChange}
                  onChange={handleChangeOtherLanguage}
                />
                {errors.other_language && (
                  <p className="text-danger">{errors.other_language}</p>
                )}
              </Grid>
            </>
          ) : (
            <>
              <Grid item xs={12} sm={12} md={6} lg={6}></Grid>
            </>
          )}

          <Grid item xs={12} sm={12} md={6} lg={6}>
            <div>
              <h6>
                {" "}
                (e) Whether the series is subtitled in English{" "}
                <span style={{ color: "red" }}>*</span>
              </h6>

              <React.Fragment>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="is_subtitle_language_eng"
                    id="is_subtitle_language_eng_yes"
                    value="1"
                    checked={formData.is_subtitle_language_eng == 1}
                    // onChange={handleChange}
                    onChange={handleMultiProductionChange}
                  />
                  <label htmlFor="is_subtitle_language_eng_yes">Yes</label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="is_subtitle_language_eng"
                    id="is_subtitle_language_eng_no"
                    value="0"
                    checked={
                      formData.is_subtitle_language_eng === 0 ||
                      formData.is_subtitle_language_eng === "0"
                    }
                    // onChange={handleChange}
                    onChange={handleMultiProductionChange}
                  />
                  <label htmlFor="is_subtitle_language_eng_no">No</label>
                </div>
                {errors.is_subtitle_language_eng && (
                  <p className="text-danger">
                    {errors.is_subtitle_language_eng}
                  </p>
                )}
                <BootstrapDialog
                  onClose={handleCloseEnglishSubtitle}
                  aria-labelledby="customized-dialog-title"
                  open={openMultiProduction}
                >
                  <DialogContent dividers>
                    <Typography gutterBottom>
                      As per clause 6.3 - The Web Series must contain English
                      subtitles.
                    </Typography>
                  </DialogContent>
                  <DialogActions>
                    <Button autoFocus onClick={handleCloseEnglishSubtitle}>
                      Ok
                    </Button>
                  </DialogActions>
                </BootstrapDialog>
              </React.Fragment>
            </div>
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={6}>
            <div>
              <div>
                <div>
                  <FormControl
                    fullWidth
                    // sx={{
                    //     width: "100%",
                    //     borderRadius: "5px",
                    // }}
                  >
                    <InputLabel id="demo-simple-select-label">
                      (f)Other languages in which subtitles are available (if
                      any)
                    </InputLabel>
                    <Select
                      name="subtitle_other_language"
                      value={formData.subtitle_other_language || ""}
                      onChange={handleChange}
                      label={
                        <span>
                          Other languages in which subtitles are available (if
                          any)
                        </span>
                      }
                      // inputProps={{ "aria-label": "Language of the Film" }}
                    >
                      <MenuItem disabled>
                        Other languages in which subtitles are available (if
                        any)
                      </MenuItem>
                      {Object.entries(subtitlelanguage).map(([key, value]) => (
                        <MenuItem key={key} value={key}>
                          {value}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </div>
            </div>
          </Grid>

          {/* <Grid item xs={12} sm={12} md={6} lg={6}>
                        
                    </Grid> */}

          {formData.subtitle_other_language == 20 ? (
            <>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  id="other_subtitle_language"
                  label={
                    <span>
                      (f.i) Other Subtitle Langauge
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  multiline
                  fullWidth
                  // maxRows={4}
                  name="other_subtitle_language"
                  value={formData.other_subtitle_language || ""}
                  // onChange={handleChange}
                  onChange={handleChangeSubtitleLanguage}
                />
                {errors.other_subtitle_language && (
                  <p className="text-danger">
                    {errors.other_subtitle_language}
                  </p>
                )}
              </Grid>
            </>
          ) : (
            <>
              <Grid item xs={12} sm={12} md={6} lg={6}></Grid>
            </>
          )}
        </Grid>
      </form>
    </>
  );
};

export default DetailsOfWebSeries;
